import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-[#22ff77] font-display tracking-widest text-sm">
        Učitavanje...
      </div>
    );
  }
  if (!user) return <Navigate to="/prijava" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
